import React, { useState } from "react";
import Select from "react-dropdown";
import { Tab, Tabs } from "react-bootstrap";
import { SUBSCRIPTIONS_PLAN_TABS } from "../../../config/configs";
import { useNavigate } from "react-router";
import { useEffect } from "react";
import { FiMinus } from "react-icons/fi";
import { useFormik } from "formik";
import {
	configSubscriptionSchema,
	subscriptionSchema,
} from "../../../validations/subscriptionValidations";
import {
	useCreateSubscriptionPlan,
	useGetRestaurantPlanById,
	usePatchRestaurantPlanById,
	useRestaurantConfig,
	useUpdateSubscriptionPlan,
} from "../../../queryHooks/useSubscriptions";
import { isEmpty } from "lodash";
import CS from "../../../services/commonService";
import { Button } from "antd";
import { useStore } from "../../../zustand/store";

const AddUpdatePlans = ({
	planConfigDetails,
	plan,
	closeModal,
	refetch,
	setShowCrossIcon,
}) => {
	const navigate = useNavigate();
	const requestBody = useStore((state) => state.requestBody);
	const setRequestBody = useStore((state) => state.setRequestBody);
	const [featureError, setFeatureError] = useState("");
	const [planFeatures, setPlanFeatures] = useState(
		plan?.features ?? ["", "", ""]
	);
	const [activeTab, setActiveTab] = useState();
	if (isEmpty(plan)) {
		plan = {
			is_active: false,
			label: "",
			price: "",
			billing_period: "",
			billing_period_unit: "DAY",
			features: ["", "", ""],
		};
	}
	const [id, setId] = useState(plan.id);
	const periodOptions = [
		{ value: "DAY", label: "DAY" },
		{ value: "MONTH", label: "MONTH" },
		{ value: "YEAR", label: "YEAR" },
	];
	const handleChangeTab = (val) => {
		setActiveTab(val);
		switch (val) {
			case SUBSCRIPTIONS_PLAN_TABS.CREATE:
				break;
			case SUBSCRIPTIONS_PLAN_TABS.CONFIGURE:
				navigate(URL.pendingRegistration);
				break;
		}
	};

	const {
		data: createPlanData,
		mutateAsync: createPlan,
		isLoading: createPlanLoading,
	} = useCreateSubscriptionPlan();
	const { mutateAsync: updatePlans, isLoading: updatePlanLoading } =
		useUpdateSubscriptionPlan();
	const [formData, setFormData] = useState({
		name: plan.label,
		price: plan.price,
		billing_period: plan.billing_period,
		billing_period_unit: plan.billing_period_unit,
		features: plan.features,
	});

	const { values, errors, handleChange, handleSubmit, touched, setFieldValue } =
		useFormik({
			initialValues: formData,
			enableReinitialize: true,
			validationSchema: subscriptionSchema,

			onSubmit: (value) => {
				setShowCrossIcon(false);
				if (!plan.id) {
					// on create subscription
					const reqBody = {
						name: value.name,
						price: value.price,
						billing_period: {
							count: value.billing_period,
							unit: value.billing_period_unit,
						},
						features: planFeatures,
					};
					setRequestBody(reqBody);
				} else {
					let reqBody = {};
					reqBody =
						value.name !== plan.label
							? { ...reqBody, name: value.name }
							: { ...reqBody };
					reqBody =
						value.price !== plan.price
							? { ...reqBody, price: value.price }
							: { ...reqBody };
					reqBody =
						value.billing_period !== plan.billing_period
							? {
									...reqBody,
									billing_period: {
										count: value.billing_period,
										unit: value.billing_period_unit,
									},
							  }
							: { ...reqBody };

					reqBody =
						value.billing_period_unit !== plan.billing_period_unit
							? {
									...reqBody,
									billing_period: {
										count: value.billing_period,
										unit: value.billing_period_unit,
									},
							  }
							: { ...reqBody };
					reqBody =
						plan.features !== planFeatures
							? { ...reqBody, features: planFeatures }
							: { ...reqBody };

					setRequestBody(reqBody);
				}
				setActiveTab(SUBSCRIPTIONS_PLAN_TABS.CONFIGURE);
			},
		});

	const handleFeatureChange = (index, event) => {
		const values = [...planFeatures];
		values[index] = event.target.value;
		setPlanFeatures(values);
	};

	const [initialConfigFormData, setInitialConfigFormData] = useState(
		id
			? {
					max_usage_limit_monthly:
						planConfigDetails?.data?.max_usage_limit_monthly ?? "",
					max_allowed_for_auto_gifting:
						planConfigDetails?.data?.max_allowed_for_auto_gifting ?? "",
					max_recipients_limit:
						planConfigDetails?.data?.max_recipients_limit ?? "",
					min_referred_users: planConfigDetails?.data?.min_referred_users ?? "",
			  }
			: {
					max_usage_limit_monthly: "",
					max_allowed_for_auto_gifting: "",
					max_recipients_limit: "",
					min_referred_users: "",
			  }
	);
	const {
		values: valuesConfig,
		errors: errorsConfig,
		handleChange: handleChangeConfig,
		handleSubmit: handleSubmitConfig,
		touched: touchedConfig,
		setFieldValue: setFieldValueConfig,
	} = useFormik({
		initialValues: initialConfigFormData,
		enableReinitialize: true,
		validationSchema: configSubscriptionSchema,
		onSubmit: (value) => {
			if (!plan.id) {
				const reqBody = {
					...requestBody,
					configuration: {
						max_allowed_for_auto_gifting: value.max_allowed_for_auto_gifting,
						max_recipients_limit: value.max_recipients_limit,
						max_usage_limit_monthly: value.max_usage_limit_monthly,
						min_referred_users: value.min_referred_users,
					},
				};
				createPlan(reqBody)
					.then((res) => {
						setShowCrossIcon(true);
						closeModal();
						setRequestBody({});
						refetch();
						CS.showSuccessMessage(res?.message);
					})
					.catch((error) => {
						setRequestBody({});
						CS.showErrorMessage(error?.response?.data?.message);
					});
			} else {
				const reqBody =
					value.max_allowed_for_auto_gifting !==
						planConfigDetails?.data?.max_allowed_for_auto_gifting ||
					value.max_usage_limit_monthly !==
						planConfigDetails?.data?.max_usage_limit_monthly ||
					value.max_recipients_limit !==
						planConfigDetails?.data?.max_recipients_limit ||
					value.min_referred_users !==
						planConfigDetails?.data?.min_referred_users
						? {
								...requestBody,
								configuration: {
									max_usage_limit_monthly: value.max_usage_limit_monthly,
									max_allowed_for_auto_gifting:
										value.max_allowed_for_auto_gifting,
									max_recipients_limit: value.max_recipients_limit,
									min_referred_users: value.min_referred_users,
								},
						  }
						: { ...requestBody };
				if (JSON.stringify(reqBody) === JSON.stringify({})) {
					closeModal();
					setRequestBody({});
					refetch();
					setShowCrossIcon(true);
					CS.showSuccessMessage("Successful");
				} else {
					updatePlans({ id, body: reqBody })
						.then((res) => {
							CS.showSuccessMessage(res?.message);
							closeModal();
							setRequestBody({});
							refetch();
							setShowCrossIcon(true);
						})
						.catch((error) => {
							CS.showErrorMessage(error?.response?.data?.message);
						});
				}
			}
			setId(null);
			setShowCrossIcon(true);
			setRequestBody({});
		},
	});
	const handleFeatureDelete = (index) => {
		setPlanFeatures((prev) => {
			const vals = [...prev];
			vals.splice(index, 1);
			return vals;
		});
	};

	useEffect(() => {
		if (id)
			setInitialConfigFormData({
				max_usage_limit_monthly:
					planConfigDetails?.data?.max_usage_limit_monthly ?? "",
				max_allowed_for_auto_gifting:
					planConfigDetails?.data?.max_allowed_for_auto_gifting ?? "",
				max_recipients_limit:
					planConfigDetails?.data?.max_recipients_limit ?? "",
				min_referred_users: planConfigDetails?.data?.min_referred_users ?? "",
			});
	}, [planConfigDetails, id]);

	return (
		<div className="m-0 w-100">
			<div className="modal-content">
				<div className="modal-header">
					<h5 className="modal-title">
						{id ? "Update Plan" : "Create New Plan"}
					</h5>
				</div>
				<div className="notification-form modal-body card profile-card password-modal">
					<Tabs
						className="pt-3 tab-block"
						id="controlled-tab-example"
						activeKey={activeTab}
						onSelect={handleChangeTab}
					>
						<Tab
							eventKey={SUBSCRIPTIONS_PLAN_TABS.CREATE}
							title={SUBSCRIPTIONS_PLAN_TABS.CREATE}
						>
							<div className="mt-5">
								<div className="row">
									<div className="col-lg-12">
										<form
										// onSubmit={(e) => handleSubmit(e)}
										>
											<div className="mb-md-12 mb-3">
												<div className="form-group mb-0">
													<label className="label xl-label">
														Name{" "}
														{!id ? <sup className="text-danger">*</sup> : null}
													</label>
													<div className="w-100 position-relative">
														<input
															className="form-control"
															type="text"
															id="name"
															name="name"
															value={values.name}
															onChange={(e) => {
																let event = {
																	target: {
																		name: "name",
																		value: e.target.value,
																	},
																};
																handleChange(event);
															}}
														/>

														<div className="error-message">
															<span className="text-danger error-msg d-block mb-2">
																{errors.name && touched.name
																	? errors.name
																	: null}
															</span>
														</div>
													</div>
												</div>
											</div>
											<div className="mb-md-4 mb-3">
												<div className="form-group mb-0">
													<label className="label xl-label">
														Price{" "}
														{!id ? <sup className="text-danger">*</sup> : null}
													</label>
													<div className="w-100 position-relative">
														<input
															className="form-control"
															type="number"
															min="0.01"
															step="0.01"
															id="name"
															name="name"
															value={values.price}
															onChange={(e) => {
																let event = {
																	target: {
																		name: "price",
																		value: e.target.value,
																	},
																};
																handleChange(event);
															}}
														/>

														<div className="error-message">
															<span className="text-danger error-msg d-block mb-2">
																{errors.price && touched.price
																	? errors.price
																	: null}
															</span>
														</div>
													</div>
												</div>
											</div>

											<div className="mb-md-4 mb-3">
												<div className="form-group mb-0">
													<label className="label xl-label">
														Billing Interval{" "}
														{!id ? <sup className="text-danger">*</sup> : null}
													</label>
													<div className="w-100 position-relative">
														<div className="d-flex">
															<input
																className="form-control flex-fill w-100"
																type="number"
																id="billing_period"
																name="billing_period"
																value={values.billing_period}
																onChange={(e) => {
																	let event = {
																		target: {
																			name: "billing_period",
																			value: e.target.value,
																		},
																	};
																	handleChange(event);
																}}
															/>
															<Select
																className="ml-3 flex-fill w-100"
																value={values.billing_period_unit}
																onChange={(option) =>
																	setFieldValue(
																		"billing_period_unit",
																		option.value
																	)
																}
																options={periodOptions}
															/>
														</div>

														<div className="error-message">
															<span className="text-danger error-msg d-block mb-2">
																{errors.billing_period && touched.billing_period
																	? errors.billing_period
																	: null}
															</span>
														</div>
													</div>
												</div>
											</div>
											<div className="mb-md-4 mb-3">
												<div className="form-group mb-0">
													<label className="label xl-label">
														Features{" "}
														{!id ? <sup className="text-danger">*</sup> : null}
													</label>
													<div className="error-message">
														<span className="text-danger error-msg d-block mb-2">
															{featureError ? featureError : null}
														</span>
													</div>
													<div className="w-100 position-relative">
														{planFeatures.map((feature, index) => (
															<div key={index} className="d-flex">
																<span className="p-1 m-2">{index + 1}. </span>{" "}
																<input
																	className="form-control mb-3"
																	type="text"
																	value={feature}
																	onChange={(e) => {
																		handleFeatureChange(index, e);
																	}}
																/>
																<div className="">
																	<button
																		className="ml-2 mt-2 btn-sm  btn-primary btn-rounded rounded-circle"
																		type="button"
																		style={{
																			width: "min-content",
																		}}
																		disabled={planFeatures.length < 3}
																		onClick={() => {
																			if (planFeatures.length > 3)
																				handleFeatureDelete(index);
																			else {
																				setFeatureError(
																					(prev) =>
																						"Minimum 3 features are required"
																				);
																			}
																		}}
																	>
																		<FiMinus />
																	</button>
																</div>
															</div>
														))}
													</div>
													<div className="row d-flex">
														<div className="mx-4 text-right">
															<button
																className="btn btn-primary"
																type="button"
																onClick={() => {
																	if (planFeatures.length < 15) {
																		setPlanFeatures([...planFeatures, ""]);
																	}
																}}
															>
																Add New Feature
															</button>
														</div>
													</div>
												</div>
											</div>

											<div className="mt-5 text-right pb-3">
												<Button
													className="btn btn-primary"
													type="submit"
													size="large"
													onClick={(e) => {
														if (
															planFeatures.includes("") |
															(planFeatures.length < 3)
														) {
															setFeatureError(
																(prev) => "At least 3 features are required"
															);
														} else {
															setActiveTab(SUBSCRIPTIONS_PLAN_TABS.CONFIGURE);
															setFeatureError((prev) => "");
														}
														handleSubmit(e);
													}}
												>
													Save and Proceed
												</Button>
											</div>
										</form>
									</div>
								</div>
							</div>
						</Tab>
						<Tab
							eventKey={SUBSCRIPTIONS_PLAN_TABS.CONFIGURE}
							title={SUBSCRIPTIONS_PLAN_TABS.CONFIGURE}
							disabled={!id && !createPlanData?.data?.id}
						>
							<div className="mt-5">
								<div className="row">
									<div className="col-lg-12">
										<form onSubmit={handleSubmitConfig}>
											<div className="mb-md-12 mb-3">
												<div className="form-group mb-0">
													<label className="label xl-label">
														Maximum attempts per month{" "}
														{!id ? <sup className="text-danger">*</sup> : null}
													</label>
													<div className="w-100 position-relative">
														<input
															className="form-control"
															type="number"
															id="max_usage_limit_monthly"
															name="max_usage_limit_monthly"
															value={valuesConfig.max_usage_limit_monthly}
															onChange={(e) => {
																let event = {
																	target: {
																		name: "max_usage_limit_monthly",
																		value: e.target.value,
																	},
																};
																handleChangeConfig(event);
															}}
														/>

														<div className="error-message">
															<span className="text-danger error-msg d-block mb-2">
																{errorsConfig.max_usage_limit_monthly &&
																touchedConfig.max_usage_limit_monthly
																	? errorsConfig.max_usage_limit_monthly
																	: null}
															</span>
														</div>
													</div>
												</div>
											</div>
											<div className="mb-md-4 mb-3">
												<div className="form-group mb-0">
													<label className="label xl-label">
														Maximum allowed recipients per attempt{" "}
														{!id ? <sup className="text-danger">*</sup> : null}
													</label>
													<div className="w-100 position-relative">
														<input
															className="form-control"
															type="number"
															name="max_recipients_limit"
															value={valuesConfig.max_recipients_limit}
															onChange={(e) => {
																let event = {
																	target: {
																		name: "max_recipients_limit",
																		value: e.target.value,
																	},
																};
																handleChangeConfig(event);
															}}
														/>

														<div className="error-message">
															<span className="text-danger error-msg d-block mb-2">
																{errorsConfig.max_recipients_limit &&
																touchedConfig.max_recipients_limit
																	? errorsConfig.max_recipients_limit
																	: null}
															</span>
														</div>
													</div>
												</div>
											</div>

											<div className="mb-md-4 mb-3">
												<div className="form-group mb-0">
													<label className="label xl-label">
														Minimum recipients for Admin approval{" "}
														{!id ? <sup className="text-danger">*</sup> : null}
													</label>
													<div className="w-100 position-relative">
														<input
															className="form-control"
															type="number"
															id="max_allowed_for_auto_gifting"
															name="max_allowed_for_auto_gifting"
															value={valuesConfig.max_allowed_for_auto_gifting}
															onChange={(e) => {
																let event = {
																	target: {
																		name: "max_allowed_for_auto_gifting",
																		value: e.target.value,
																	},
																};
																handleChangeConfig(event);
															}}
														/>

														<div className="error-message">
															<span className="text-danger error-msg d-block mb-2">
																{errorsConfig.max_allowed_for_auto_gifting &&
																touchedConfig.max_allowed_for_auto_gifting
																	? errorsConfig.max_allowed_for_auto_gifting
																	: null}
															</span>
														</div>
													</div>
												</div>
											</div>
											<div className="mb-md-4 mb-3">
												<div className="form-group mb-0">
													<label className="label xl-label">
														Minimum Referred users for claiming promo gifts{" "}
														{!id ? <sup className="text-danger">*</sup> : null}
													</label>
													<div className="w-100 position-relative">
														<input
															className="form-control"
															type="number"
															id="min_referred_users"
															name="min_referred_users"
															value={valuesConfig.min_referred_users}
															onChange={(e) => {
																let event = {
																	target: {
																		name: "min_referred_users",
																		value: e.target.value,
																	},
																};
																handleChangeConfig(event);
															}}
														/>

														<div className="error-message">
															<span className="text-danger error-msg d-block mb-2">
																{errorsConfig.min_referred_users &&
																touchedConfig.min_referred_users
																	? errorsConfig.min_referred_users
																	: null}
															</span>
														</div>
													</div>
												</div>
											</div>

											<div className="mt-5 text-right">
												<button className="btn btn-primary" type="submit">
													Submit
												</button>
											</div>
										</form>
									</div>
								</div>
							</div>
						</Tab>
					</Tabs>
				</div>
			</div>
		</div>
	);
};

export default AddUpdatePlans;
